/**
 * How long an external apply-query waits for the grid's own data fetch to settle
 * before it reports the apply as failed. Generous on purpose — a slow /count +
 * /data pair on a large grid is still a successful apply — but bounded, so a
 * fetch that never settles (aborted, superseded, dropped) can't leave the caller
 * waiting forever.
 */
export const APPLY_QUERY_FETCH_SETTLE_TIMEOUT_MS = 30_000;
